module.exports = {"POOLS":{"TITLE":"Liquidity pools","WARNING":"Sorry! There isn't any pool. You can add the first","POOL":{"TITLE":"Pool detail information","ID":"Pool ID:","NAME":"Pool name:","TYPE":"Pool type:","SENDER_INFORMATION":"Ultimate Sender Information:","COULD_CREATE_ACCOUNT_UNDER_POOL":"Can your customers fund their current account through this liquidity pool? If yes, you need to make it a public pool and define funding instructions:","PUBLIC_PERMISSION":"Public","PRIVATE_PERMISSION":"Private"}}}


//////////////////
// WEBPACK FOOTER
// ./src/dashboard/app/core/translate/translations/en/pool.json
// module id = 697
// module chunks = 0